import { batch } from 'react-redux';

import { requestSlots } from '@r1-frontend/service-engineer-visit/actions';
import {
    selectDeliveryOption as selectDeliveryOptionAction,
} from '@r1-frontend/service-engineer-visit/actions/simple';
import { TContextDispatch } from '@r1-frontend/service-engineer-visit/context/Context';
import { TDeliveryOption } from '@r1-frontend/service-engineer-visit/types/TDeliveryOption';

/**
 * @param deliveryOption
 * @param domain rudiment
 * @param productId
 */
const selectDeliveryOption = (deliveryOption: TDeliveryOption, domain: string, productId: number | undefined, gaLabel?: string | undefined) =>
    async(dispatch: TContextDispatch) => {
        batch(() => {
            dispatch(selectDeliveryOptionAction(deliveryOption));
            // @ts-ignore
            dispatch(requestSlots(productId, gaLabel));
        });
    };

export default selectDeliveryOption;
